module.exports = __webpack_public_path__ + "01_hige_white.8a06e480.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/01_hige_white.png
// module id = fJRd
// module chunks = 0